import Card from 'components/Card';
import MultiImageUploader from 'components/Form/Input/Image/MultiUploader';
import SingleImageUploader from 'components/Form/Input/Image/SingleUploader';
import PageTitle from 'components/Title/Page';
import React, { useState } from 'react';
import { getS3UploadUrl, uploadS3File } from 'utils/s3';

const ImagePage = () => {
    const [files, setFiles] = useState([]);

    const handleFileSelected = async (file) => {
        // const upLoadUrl = await getS3UploadUrl(file[0]);
        // console.log("[handleFileSelected] upLoadUrl", upLoadUrl);
        // const ret = await uploadS3File(file[0], upLoadUrl);
        // console.log("[handleFileSelected] ret", ret);
    }

    return (
        <Card>
            <div className="p-3">
                <PageTitle>이미지 테스트</PageTitle>
                <MultiImageUploader
                    files={files}
                    onFileSelected={(newFiles)=>{setFiles((prev)=>[...prev, ...newFiles])}}
                    onFileChanged={setFiles}
                />
            </div>
        </Card>
    );
};

export default ImagePage;
